module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<%\n  var hasDescription = !!description.length;\n  var hasSponsor = (sponsor === '1' && sponsor_image.length);\n%> <div class=\"description-wrapper\"> <% if( hasDescription ) { %> <p class=\"cat-description\"><%- description %></p> <% } %> <% if( hasSponsor ) { %> <div class=\"sponsor\"> <span><%- (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text %></span> <img src=\"<%= sponsor_image %>\" alt=\"\"> </div> <% } %> </div> <div class=\"contestants-wrapper\"></div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1;
  var hasDescription = !!description.length;
  var hasSponsor = (sponsor === '1' && sponsor_image.length);
; buf.push(' <div class="description-wrapper"> ');__stack.lineno=4; if( hasDescription ) { ; buf.push(' <p class="cat-description">', (__stack.lineno=4,  description ), '</p> ');__stack.lineno=4; } ; buf.push(' ');__stack.lineno=4; if( hasSponsor ) { ; buf.push(' <div class="sponsor"> <span>', (__stack.lineno=4,  (typeof sponsor_text !== 'undefined') ? sponsor_text : copy.sponsor_text ), '</span> <img src="', escape((__stack.lineno=4,  sponsor_image )), '" alt=""> </div> ');__stack.lineno=4; } ; buf.push(' </div> <div class="contestants-wrapper"></div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/category.ejs
// module id = 231
// module chunks = 0